export enum SuccessCodes {
  REGISTRATION_COMPLETED = 'REGISTRATION_COMPLETED',
  PASSWORD_RESET_COMPLETED = 'PASSWORD_RESET_COMPLETED',
}
